module.exports = __webpack_public_path__ + "static/media/password.b9460ceb.svg";